<template >
  <boxDropDown title="Alteração do fuso horário do turno">
    <template>

      <div class="form-group col-xs-6 col-sm-6 col-md-6">
        <label for="companyIdInput">ID da empresa</label>
        <input type="text" class="form-control" placeholder="Insira o ID da empresa" id="companyIdInput" name="companyIdInput" 
        v-model="companyId" @blur="checkField('companyIdInput')">
      </div>

      <div class="form-group col-xs-6 col-sm-6 col-md-6">
        <label for="workshiftIdInput">ID do turno</label>
        <input type="text" class="form-control" placeholder="Insira o ID do turno" id="workshiftIdInput" name="workshiftIdInput" 
        v-model="workshiftId" @blur="checkField('workshiftIdInput')">
      </div>

      <div v-if="errorMessage" class="text-danger col-xs-12 col-sm-12 col-md-12 text-center spacing-bottom" role="alert">
        {{ errorMessage }}
      </div>

      <div class="form-group col-md-12 full-width">
        <div class="form-group">
          <label>Fuso horário</label>
          <select name="selectGMT" id="selectGMT" v-model="GMTHour" class="form-control">
            <option value="">Selecione o fuso horário do turno com base horário de Greenwich</option>
            <option v-for="(gmtValue, index) in this.GMTAvailables" :key="index">
              {{ gmtValue }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group col-md-12 full-width text-center">
        <button class="btn btn-primary" @click="handleUpdateWorkShiftTimeZone()">
          <span v-if="!loadingUpdateWorkShiftTimeZone">Alterar fuso horário</span>
          <span v-else class="loading-btn">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </span>
        </button>
      </div>
      <!-- <button class="btn btn-primary" @click="handleUpdateWorkShiftTimeZone()">Alterar fuso horário</button> -->
    </template>
  </boxDropDown>
</template>

<script>
import {
  CONTEXT_COMPANY,
  UPDATE_WORKSHIFT_TIMEZONE,
} from "../../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../../msgAlertService";
import boxDropDown from "../../../components/layouts/boxDropDown.vue";

export default {
    name: "workshift-timezone-tool",
    components: {
      boxDropDown
    },
    data() {
      return {        
        showAlterWorkShiftTimeZone: false,
        companyId: '',
        workshiftId: '',
        GMTHour: '',
        errorMessage: '',
        contentSetting: '',
        GMTAvailables: [
          'GMT -12:00',
          'GMT -11:00',
          'GMT -10:00',
          'GMT -09:00',
          'GMT -08:00',
          'GMT -07:00',
          'GMT -06:00',
          'GMT -05:00',
          'GMT -04:00',
          'GMT -03:00',
          'GMT -02:00',
          'GMT -01:00',
          'GMT +00:00',
          'GMT +01:00',
          'GMT +02:00',
          'GMT +03:00',
          'GMT +04:00',
          'GMT +05:00',
          'GMT +06:00',
          'GMT +07:00',
          'GMT +08:00',
          'GMT +09:00',
          'GMT +10:00',
          'GMT +11:00',
          'GMT +12:00'
        ],
        loadingUpdateWorkShiftTimeZone: false
      }
    },
    methods: {
      handleUpdateWorkShiftTimeZone(){
        this.checkField("workshiftIdInput");
        if(this.errorMessage != ''){
          return;
        }

        this.checkField("companyIdInput");
        if(this.errorMessage != ''){
          return;
        }

        let bodyRequest = {
            companyId: this.companyId.trim(),
            workshiftId: this.workshiftId.trim(),
            GMTHour: this.GMTHour
          };

        this.loadingUpdateWorkShiftTimeZone = true;
        
        REQUEST_SERVICE.get(`${CONTEXT_COMPANY}${this.companyId}`).then((response) => {
          this.contentSetting = response.data;

          let bodyRequestJSON = JSON.stringify(bodyRequest);
          console.log(bodyRequestJSON + this.contentSetting);
          REQUEST_SERVICE.requestContext('PUT', UPDATE_WORKSHIFT_TIMEZONE, this.contentSetting, bodyRequestJSON).then((response) => {
            ALERT_SERVICE.swal("Sucesso", "Fuso horário do turno alterado com sucesso!", "success");
            this.clearFields();
            this.loadingUpdateWorkShiftTimeZone = false;
          }).catch((reason) => {
            this.loadingUpdateWorkShiftTimeZone = false;
            if(reason.response.data.erros.length > 0){
              ALERT_SERVICE.swal("ERRO", reason.response.data.erros[0].value, "error");
            }else{
              ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
            }
          });
        }).catch((reason) => {
          this.loadingUpdateWorkShiftTimeZone = false;
          if(reason.response.data.erros.length > 0){
              ALERT_SERVICE.swal("ERRO", reason.response.data.erros[0].value, "error");
            }else{
              ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
            }
        });
      },
      checkField(nameOfInput){
        if(nameOfInput === "companyIdInput" || nameOfInput === "workshiftIdInput"){
          if(this.companyId.trim().length != 32 || this.workshiftId.trim().length != 32){
            this.errorMessage = "Os IDs devem conter 32 caracteres";
            return;
          }
        }
        this.errorMessage= '';
      },
      clearFields(){
        this.companyId = '';
        this.workshiftId = '';
        this.GMTHour = '';
        this.errorMessage = '';
        this.contentSetting = '';
      }
    }
  }
  </script>
  
  <!-- <style scoped> -->
  <style lang="scss">

  * {
    font-family: "Montserrat", sans-serif !important;
  }

  .full-width{
    width: 100% !important;
  }

  .spacing-bottom{
    margin-bottom: 8px;
  }


  ul{
    list-style: none;
  }

  </style>


// WEBPACK FOOTER //
// src/vue/pages/restricted/support/supportItems/workShiftTimeZoneTool.vue